import { Badge, Collapse, Flex, Space, Typography } from 'antd'
import styles from '../styles.module.css'

type Props = {
  budgetPeriodName: string | null
}

export const TeamEmpty = ({ budgetPeriodName }: Props) => {
  const { Title, Text } = Typography

  return (
    <Collapse
      items={[
        {
          key: '1',
          label: (
            <Space>
              <Text strong style={{ fontSize: 28 }}>
                Заявки команды / {budgetPeriodName ?? ''}
              </Text>
              <Badge
                count={0}
                showZero
                color="white"
                style={{ color: 'black', borderRadius: '4px' }}
              />
            </Space>
          ),
          children: (
            <Flex
              vertical
              justify="center"
              align="center"
              style={{ textAlign: 'center', height: 200 }}
            >
              <Title level={3}>Заявок на согласование нет</Title>
              <Text style={{ fontSize: 16 }}>
                Как только сотрудники начнут создавать заявки, они будут
                оказываться здесь и<br /> ждать согласования
              </Text>
            </Flex>
          ),
        },
      ]}
      defaultActiveKey="1"
      className={styles.collapse}
      expandIconPosition="end"
      style={{ backgroundColor: 'var(--color-blue-20)' }}
    />
  )
}
